import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "position-absolute top-0 start-0 end-0 bottom-0",
  style: {"margin-top":".75rem"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-white",
  role: "status"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    disabled: _ctx.loading,
    type: "submit",
    class: _normalizeClass(["btn btn-warning py-3 shadow-sm position-relative", _ctx.classes])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass({ 'opacity-0': _ctx.loading })
    }, _toDisplayString(_ctx.btnTitle), 3)
  ], 10, _hoisted_1))
}